import React from "react";
import { Markup } from "interweave";
import flag from "../../../../assets/images/flag.png";
import flag1 from "../../../../assets/images/Registration-End-01.1.png";
import flag2 from "../../../../assets/images/Maximum-Time-01.1.png";
import flag3 from "../../../../assets/images/Minimum-Time-01.1.png";
import moment from "moment";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../App";
import { useContext } from "react";

const ScheduleTableCard = ({ props, participant }) => {

  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <div className="card card-bg p-2">
            {props.banner ? (
              <img
                src={imageCdnUrl + props.banner}
                className="img-fluid"
                alt=""
                style={{
                  height: "200px",
                  width: "300px",
                }}
              />
            ) : (
              <>
                {props.image ? (
                  <img
                    src={imageCdnUrl + props.image}
                    className="img-fluid"
                    alt=""
                    style={{
                      height: "200px",
                      width: "300px",
                    }}
                  />
                ) : (
                  <ReactPlayer
                    url={videoCdnUrl + props.video}
                    controls={true}
                    volume={1}
                    width="100%"
                    height="200px"
                    style={{ margin: "0 auto" }}
                  />
                )}
              </>
            )}
          </div>
        </div>

        <div className="col-md-6 mb-3">
          <div className="card bg-dark">
            <div className="row">
              <div className="registration-head  card-bg mb-1">
                <h5 className="text-warning fw-bold p-2">Registration </h5>
              </div>

              <div className="row registration-body  card-bg m-0 pt-3">
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Fee :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {props.fee
                          ? props.fee
                          : props.cost
                            ? props.cost
                            : props.unit_price
                              ? props.unit_price
                              : props.base_price
                                ? props.base_price
                                : props.price}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag1} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Participate :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {participant?.length}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag2} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Date :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(props.created_at).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag3} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Time :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(props.created_at).format("HH:mm a")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-md-12">
          <div className="card card-bg shadow">
            <div className="card-body">
              <h5 className="text-light pb-3">
                {props.title ? props.title : props.group_name}
              </h5>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={props.description} />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="col-md-12 mb-3">
          <h5 className="text-warning fw-bold">Participate List</h5>

          <div className="tr-odd-wallet">
            <table className="table w-100">
              <thead className="bg-warning">
                <tr>
                  <th scope="col" className="text-black fw-bold">
                    #
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Name
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Email
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Register Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {participant.map((participate) => (
                  <tr className="tr-child-wallet">
                    <th scope="row">1</th>
                    <td>
                      {participate?.user?.first_name}
                      {participate?.user?.last_name}
                    </td>
                    <td>{participate?.user?.email}</td>
                    <td>
                      {moment(participate?.created_at).format("LL")}
                      {moment(participate?.created_at).format("HH:mm a")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleTableCard;
